// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2d2ff4c5462516dd2544","691":"80cf9301e45e86323056"}[chunkId] + ".js";
};